export default "__VITE_ASSET__CHBOXFvg__"